import React, { useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useParams
} from "react-router-dom";

import { useDispatch, useSelector } from 'react-redux';

import '../sass/main.scss';
import { setDB } from '../redux/db.act';
import { logout } from '../redux/user.act';
import useAuth from '../hooks/useAuth';
import RedirectComponent from './components/RedirectComponent';

const Home = React.lazy(() => import('./screens/home/Home'));
const Otp = React.lazy(() => import('./screens/otp/OtpWrapper'));
const Intro = React.lazy(() => import('./screens/intro/Intro'));
const Hospitalization = React.lazy(() => import('./screens/hospitalization/Hospitalization'));
const Discharge = React.lazy(() => import('./screens/discharge/Discharge'));
const WaitingScreen = React.lazy(() => import('./screens/share/WaitingScreen'));
const AuthWrapper = React.lazy(() => import('./components/auth_wrapper/AuthWrapper'));
const Logout = React.lazy(() => import('./screens/logout/Logout'));
const Auth = React.lazy(() => import('./components/auth_wrapper/Auth'));
const CheckVisitId = React.lazy(() => import('./components/auth_wrapper/CheckVisitId'));
const Share = React.lazy(() => import('./screens/share/Share'));
const Popup = React.lazy(() => import('./components/popup/Popup'));
const Layout = React.lazy(() => import('./components/layout/Layout'));
const NanoidCheck = React.lazy(() => import('./components/auth_wrapper/NanoidCheck'));
const Transfer = React.lazy(() => import('./screens/transfer/Transfer'));
const Terms = React.lazy(() => import('./screens/terms/Terms'));
const FullScreenPreloader = React.lazy(() => import('./components/preloader/Preloader'));
const FoodCoupon =  React.lazy(() => import('./screens/FoodCoupon/FoodCoupon'))

function App() {
  
  const { socket } = window;
  const dispatch = useDispatch();
  const [sharedPersonData, setSharedPersonData] = useState({});
  const [loading, setLoading] = useState(false);
  const { isLoggedIn } = useAuth();
  const isUserLoggedIn = isLoggedIn();
 
  const setChangedDB = ({ success, data, errors }) => {
    if (success) {
      dispatch(setDB(data));
    }
    setLoading(false);
  }

  const userLogout = () => {
    dispatch(logout());
  }

  const triggerPopup = () => {
    let hangoutButton = document.getElementById("exampleModalToggleId");
    hangoutButton.click();
  }

  const setPopupData = ({ success, data, errors }) => {
    if (success) {
      setSharedPersonData(data);
      triggerPopup();
      
    }
  }
  
  useEffect(() => {
    socket.on('db:db-changed', setChangedDB);
    socket.on('user:user-logout', userLogout);
    socket.on("share:requested-access", setPopupData);
  }, []);

  return (
    <div className="App">
      <React.Suspense fallback={<FullScreenPreloader />}>
        <Router>
          <Routes>
            <Route exact path="/otp" element={<RedirectComponent />} />   
            <Route exact path="/share" element={<RedirectComponent />} />
            <Route exact path="/confirm" element={<RedirectComponent />}/>
            <Route exact path="/foodCoupon" element={<RedirectComponent />}/>            
            <Route exact path="/:VisitId/home" element={<AuthWrapper setLoading={setLoading}><Layout ><Home /></Layout></AuthWrapper>} />
            <Route exact path="/:VisitId/home/:nanoid" element={<AuthWrapper setLoading={setLoading} withRedirect={false}><Layout><Home isShare /></Layout></AuthWrapper>} />
            <Route exact path="/:VisitId/info" element={<AuthWrapper setLoading={setLoading}><Layout><Home screenInd={1} /></Layout></AuthWrapper>} />
            <Route exact path="/:VisitId/intro/*" element={<AuthWrapper setLoading={setLoading} withRedirect={false}><Layout><Intro /></Layout></AuthWrapper>} />
            <Route exact path="/:VisitId/otp" element={<Layout isWithoutImage><Otp /></Layout>} />
            {/* <Route exact path="/:VisitId/otp" element={<CheckVisitId><Layout isWithoutImage><Otp /></Layout></CheckVisitId>} /> */}
            <Route exact path="/:VisitId/hospitalization" element={<AuthWrapper setLoading={setLoading}><Layout><Hospitalization /></Layout></AuthWrapper>} />
            <Route exact path="/:VisitId/discharge" element={<AuthWrapper setLoading={setLoading}><Layout><Discharge /></Layout></AuthWrapper>} />
            <Route exact path="/:VisitId/share" element={<AuthWrapper withRedirect={false} setLoading={setLoading}><Share /></AuthWrapper>} />
            <Route exact path="/:VisitId/transfer" element={<AuthWrapper setLoading={setLoading}><Layout><Transfer /></Layout></AuthWrapper>} />            
            <Route exact path="/:VisitId/FoodCoupon" element={ <AuthWrapper withRedirect={false} setLoading={setLoading}><FoodCoupon  /></AuthWrapper>} />
            <Route exact path="/share/:nanoid" element={<NanoidCheck><Layout isWithoutImage shared><WaitingScreen /></Layout></NanoidCheck>} />
            <Route exact path="/share/:nanoid/home" element={<AuthWrapper setLoading={setLoading} shared><Layout isWithoutImage shared><Home shared /></Layout></AuthWrapper>} />
            <Route exact path="/share/:nanoid/info" element={<AuthWrapper setLoading={setLoading} shared><Layout isWithoutImage shared  ><Home screenInd={1} shared /></Layout></AuthWrapper>} />
            <Route exact path="/logout" element={<Auth><Layout><Logout /></Layout></Auth>} />
            <Route exact path="/terms" element={<Layout isWithoutImage isTermsPage><Terms /></Layout>} />
            let 
            <Route exact path="*" element={<div>404 page</div>} />
          </Routes>
        </Router>

        {isUserLoggedIn && <Popup sharedPersonData={sharedPersonData} />}
        {loading && <FullScreenPreloader />}
      </React.Suspense>
    </div>
  );
}

export default App;
